import { useContext } from 'react'
import { FrequenciesFilterContext } from '.'

export default function useFrequenciesFilter() {
  return useContext(FrequenciesFilterContext)
}
